import { useRouter } from 'next/router';
import React from 'react';

import { ThankYouConnector } from '@modules/thankYou/ThankYouConnector';

const ThankYouPage = () => {
  const router = useRouter();
  const { payment_intent } = router.query;

  return <ThankYouConnector payment_intent={payment_intent as string} />;
};

export default ThankYouPage;
